import styled, { CSSObject } from '@emotion/styled';
import React, { FC } from 'react';
import { V1Sizes } from '@lithos';
import { LithosComponent } from './LithosComponent';

type GridTemplateColumns = React.CSSProperties['gridTemplateColumns'];
type GridTemplateRows = React.CSSProperties['gridTemplateRows'];
type AlignItems = React.CSSProperties['alignItems'];
type JustifyItems = React.CSSProperties['justifyItems'];

interface FlexGridProps {
  children: React.ReactNode;
  columns?: GridTemplateColumns;
  rows?: GridTemplateRows;
  gapSize?: V1Sizes;
  padding?: V1Sizes;
  alignItems?: AlignItems;
  justifyItems?: JustifyItems;
  css?: CSSObject;
  ['data-testid']?: string;
}

const Wrapper = styled.div<FlexGridProps>`
  display: grid;
  grid-template-columns: ${({ columns }) => columns};
  grid-template-rows: ${({ rows }) => rows};
  gap: ${({ theme, gapSize }) => `${theme.v1.size[gapSize as V1Sizes]}px`};
  width: 100%;
  height: 100%;
  justify-items: ${({ justifyItems }) => justifyItems};
  align-items: ${({ alignItems }) => alignItems};
  padding: ${({ theme, padding }) => `${theme.v1.size[padding as V1Sizes]}px`};
  ${({ css }) => css};
`;

const FlexGrid: LithosComponent<FlexGridProps> = ({
  children,
  columns = '1fr',
  rows = 'auto',
  gapSize = '1',
  padding = '1',
  alignItems = 'stretch',
  justifyItems = 'start',
  css = {},
  testId,
}) => {
  return (
    <Wrapper
      columns={columns}
      rows={rows}
      gapSize={gapSize}
      padding={padding}
      alignItems={alignItems}
      justifyItems={justifyItems}
      css={css}
      data-testid={testId}
    >
      {children}
    </Wrapper>
  );
};

export default FlexGrid;
